import { ArticleSortType, Label } from '@wix/answers-api';

import { Store } from '.';
import { RoadmapFeatureResolution, RoadmapFilter } from '../../types';

export type RoadmapSlice = {
  sortType?: ArticleSortType;
  roadmapFilter?: RoadmapFilter;
  resolution?: RoadmapFeatureResolution;
  roadmapLabels?: Label[];
  label?: { name: string; id: string };
  setRoadmapData: (
    data: Partial<Omit<RoadmapSlice, 'setRoadmapData'>>
  ) => void;
};

export const getRoadmapInitialState = (
  set: (stateUpdater: (state: Store) => Partial<Store>) => void
): RoadmapSlice => ({
  sortType: undefined,
  roadmapFilter: undefined,
  resolution: undefined,
  roadmapLabels: undefined,
  label: undefined,
  setRoadmapData: (data) => {
    set((state) => ({
      roadmapSlice: {
        ...state.roadmapSlice,
        ...data,
      },
    }));
  },
});
